/**
 * ClientEoaEBanner — client-facing notification (Spanish) that the trainer
 * has shared an "End of an Era" report. Opens the full Spanish experience in
 * a new tab. Dismiss marks it seen so the banner won't show again.
 */
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { ScrollText, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ClientEoaEBanner = () => {
  const [report, setReport] = useState(null);

  const fetchShared = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/eoae/client/shared`);
      setReport(res.data || null);
    } catch (e) {
      setReport(null);
    }
  }, []);

  useEffect(() => { fetchShared(); }, [fetchShared]);

  const open = () => {
    if (!report) return;
    window.open(`/eoae/${report.id}`, '_blank');
  };

  const dismiss = async (e) => {
    e.stopPropagation();
    if (!report) return;
    try {
      await axios.post(`${API}/eoae/${report.id}/seen`);
    } catch (_) { /* noop */ }
    setReport(null);
  };

  if (!report) return null;

  return (
    <div
      onClick={open}
      className="cursor-pointer mb-6 rounded-2xl overflow-hidden border border-[#D4AF37]/40 bg-gradient-to-r from-[#1a1407] via-[#2a2008] to-[#1a1407] shadow-[0_0_30px_rgba(212,175,55,0.15)] hover:shadow-[0_0_40px_rgba(212,175,55,0.25)] transition-all"
      data-testid="client-eoae-banner"
    >
      <div className="flex items-center gap-4 p-5">
        <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#D4AF37]/20 flex items-center justify-center">
          <ScrollText className="w-6 h-6 text-[#D4AF37]" />
        </div>
        <div className="flex-1">
          <p className="text-[#D4AF37] text-xs uppercase tracking-[0.25em] font-semibold">End of an Era</p>
          <p className="text-white font-semibold mt-0.5">
            Tu entrenador ha compartido contigo tu informe End of an Era.
          </p>
          <p className="text-amber-100/70 text-sm mt-0.5">Toca para revivir todo tu recorrido.</p>
        </div>
        <button
          onClick={dismiss}
          className="text-amber-200/60 hover:text-white p-2"
          data-testid="client-eoae-dismiss"
          aria-label="Cerrar"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default ClientEoaEBanner;
